import React, { useState, useEffect, Fragment } from 'react'
import {Paper, Grid } from "@material-ui/core";
import { globalGetService } from '../../../utils_v2/globalApiServices';
import { withRouter } from 'react-router';
import { AuditListing, fisAuditFilters, auditListHd } from '../components';
import checkApiStatus from '../../../utils';
import { EmptyCollection, PageLoader, TableListComp, FilterComponent } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { trackActivity } from '../../../utils/mixpanel';

function FisAudit() {
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});
    const [fisAudit, setFisAudit] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getFisAudit({ ...filter, per_page: 20 }, 'skeletonLoader')
        trackActivity('FIS-Audit Hanwha - Lease Management', {
            event_type: 'Page Visited',
            page_title: 'FIS-Audit Listing'
        });
    }, [])

    const getFisAudit = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`contracts/invoice-audit-log-report/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setFisAudit({ list: response?.data?.data?.list || [], pagination: response?.data?.data?.pagination || {} });
                    delete query.page
                    delete query.per_page
                    delete query.sort
                    delete query.sort_by
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }


    const createSortHandler = (sortField) => {
        setSortInfo((prev) => {
            const isSameField = prev.sort === sortField;
            const nextSortBy = isSameField ? prev.sort_by === 'asc' ? 'desc' : 'asc' : 'asc';
            getFisAudit({ ...filter, sort: sortField, sort_by: nextSortBy, per_page: 20 }, 'pageLoader');
            return { sort: sortField, sort_by: nextSortBy };
        });
    };

    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    return (
        <section className='fis-audit' style={{ marginLeft: '80px', marginTop: '20px' }}>
            {skeletonLoader ? <STableLoader count={10} /> :
                <Fragment>
                    <Paper square style={{ padding: '6px 10px' }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={9}>
                                <FilterComponent
                                    filter={filterObj}
                                    filterMenu={fisAuditFilters}
                                    getResponseBack={(applyFilter) => { getFisAudit({ ...applyFilter, page: 1, per_page: fisAudit.pagination.per_page }, 'pageLoader'); }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <TableListComp
                        heads={auditListHd}
                        sort={sortInfo?.sort}
                        sort_by={sortInfo?.sort_by}
                        data={fisAudit?.list.map((item, index) =>
                            <AuditListing
                                index={index}
                                item={item} />
                        )
                        }
                        createSortHandler={(key) => createSortHandler(key)}
                        onChangePage={(event, newPage) => { getFisAudit({ ...filter, page: newPage + 1, per_page: fisAudit.pagination.per_page, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }, 'pageLoader') }}
                        onChangeRowsPerPage={(event) => { getFisAudit({ ...filter, page: 1, per_page: event.target.value, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }, 'pageLoader') }}
                        pagination={fisAudit.pagination}
                        noRecord={fisAudit.list.length ? null :
                            <EmptyCollection
                                title="No records found"
                            />
                        }
                    />
                </Fragment>
            }
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}

export default withRouter(FisAudit)